
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'

interface AdminAuthGuardProps {
  children: React.ReactNode
}

const AdminAuthGuard = ({ children }: AdminAuthGuardProps) => {
  const [loading, setLoading] = useState(true)
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const check = async () => {
      try {
        // Must have a Supabase session
        const { data } = await supabase.auth.getSession()
        const userId = data.session?.user?.id

        if (!userId) {
          navigate('/admin/login')
          return
        }

        // Must be listed in admins table
        const { data: adminRow } = await supabase
          .from('admins')
          .select('user_id')
          .eq('user_id', userId)
          .maybeSingle()

        if (!adminRow) {
          navigate('/admin/login')
          return
        }

        // Optional: keep local flag for continuity with existing UX
        localStorage.setItem('adminSession', 'true')
        setIsAdminAuthenticated(true)
      } finally {
        setLoading(false)
      }
    }
    check()
  }, [navigate])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  return isAdminAuthenticated ? <>{children}</> : null
}

export default AdminAuthGuard
